/* eslint-disable react/jsx-no-duplicate-props */
import { useState, useEffect } from 'react';
import { Table as AntTable, Checkbox, Flex, Tooltip } from 'antd';
import { classNames } from 'src/utilities';
import { ModalComponent } from './Modal';
import { AlertIcon } from '../../../../icons';
import { listEncounters, removeEncounter } from '../../store/actions/encounter';
import { useDispatch, useSelector } from 'react-redux';
import { showToastSuccess } from '../../../../utilities/toast';
import { showToastError } from '../../../../utilities/errortoast';
import { Button } from './Button';
import sortUp from '/src/assets/sortUp.svg';
import sortDown from '/src/assets/sortDown.svg';
import { selectedEncounterSlice } from '../../store/slices/encounter';

export const EncounterTable = ({
  className,
  rowClassName,
  columns,
  rowKey,
  loading,
  onRow,
  dataSource,
  setSearchFilters,
  setStartDate,
  setEndDate,
  storedParams,
  selectedRowKeys,
  setSelectedRowKeys,
  handleEncountersSorting,
  sortedInfo,
}) => {
  const dispatch = useDispatch();
  const [tableColumns, setTableColumns] = useState([]);
  const [isDeleteMultipleModalVisible, setisDeleteMultipleModalVisible] =
    useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const getSelectedRowDetails = () => {
    const selectedRows = dataSource.filter((row) =>
      selectedRowKeys?.includes(row.encounter_id)
    );
    return selectedRows;
  };

  const handleDelete = () => {
    setisDeleteMultipleModalVisible(true);
  };

  useEffect(() => {
    // Here you can set the width for each column
    const modifiedColumns = columns.map((column) => ({
      ...column,
      width: 2000, // Set your desired width here
    }));
    const columnsWithCheckbox = [
      ...modifiedColumns, // Existing columns
      {
        title: '',
        key: 'selection',
        render: (_, record) => (
          <div className="checkbox-container pr-1">
            <Checkbox
              checked={selectedRowKeys?.includes(record.encounter_id)}
              onChange={(e) => {
                const newSelectedKeys = e.target.checked
                  ? [...selectedRowKeys, record.encounter_id] // Add encounter_id
                  : selectedRowKeys?.filter((id) => id !== record.encounter_id); // Remove encounter_id
                setSelectedRowKeys(newSelectedKeys);
              }}
            />
          </div>
        ),
      },
    ];
    setTableColumns(columnsWithCheckbox);
    // TODO: FIX this use effect dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns, setSelectedRowKeys]);

  const hasSelected = selectedRowKeys?.length > 0;

  const handleDeleteMultipleEncounters = async () => {
    const selectedRows = getSelectedRowDetails();
    if (!selectedRows.length) {
      return;
    }
    setSubmitLoading(true);
    const selectedEncounter = localStorage.getItem(
      `${currentPractitioner?.org_uuid}_selectedEncounter`
    )
      ? JSON.parse(
          localStorage.getItem(
            `${currentPractitioner?.org_uuid}_selectedEncounter`
          )
        )
      : null;

    try {
      for (const row of selectedRows) {
        if (row.encounter_id === selectedEncounter?.encounter_id) {
          localStorage.removeItem(
            `${currentPractitioner?.org_uuid}_selectedEncounter`
          );
        }
        await dispatch(
          removeEncounter(
            row.encounter_id, //  'encounter_id' is the unique identifier for each row
            storedParams,
            setSubmitLoading,
            false
          )
        );
      }
      showToastSuccess('Removed encounter(s)');
    } catch (error) {
      console.error('Error deleting encounter(s):', error);
      showToastError('Failed to delete encounter(s)');
    } finally {
      setSubmitLoading(false);
      dispatch(selectedEncounterSlice(null));
      dispatch(listEncounters(storedParams, true));
      // Clear the selected row keys
      setSelectedRowKeys([]);
      setisDeleteMultipleModalVisible(false);
    }
  };

  const handleCancel = () => {
    setSubmitLoading(false);
    setisDeleteMultipleModalVisible(false);
  };

  return (
    <>
      <div className={classNames('', className ? className : '')}>
        <Flex vertical>
          <div className="sticky top-0 card-title bg-[#fff] text-base flex justify-between z-10 p-2 shadow-sm empty:hidden">
            <div className="flex items-center justify-between gap-6">
              <div className="flex items-center gap-2 text-xs text-[#000000e0]">
                <Tooltip
                  title={
                    sortedInfo?.order === 'asc'
                      ? 'Oldest first'
                      : 'Newest first'
                  }
                  placement="topLeft"
                >
                  <div
                    onClick={handleEncountersSorting}
                    className="border-[1.5px] border-gray-400 rounded cursor-pointer"
                  >
                    <img
                      src={sortedInfo?.order === 'desc' ? sortUp : sortDown}
                      alt={
                        sortedInfo?.order === 'desc' ? 'sort-up' : 'sort-down'
                      }
                      height={18}
                      width={18}
                    />
                  </div>
                </Tooltip>
                Sort
              </div>
            </div>
            {hasSelected ? (
              <Button
                type={'button'}
                className=" bg-[#d63232] hover:bg-[#a30000] border-[#d63232] hover:border-[#a30000] hover:underline text-xs rounded-full h-8 grow-0 shrink-0 !px-3"
                initialActive={true}
                onClick={handleDelete}
              >
                {`Delete ${selectedRowKeys?.length} item(s)`}
              </Button>
            ) : null}
          </div>

          <AntTable
            columns={tableColumns}
            rowClassName={rowClassName}
            dataSource={dataSource}
            loading={loading}
            pagination={false}
            showHeader={false}
            onRow={onRow}
            rowKey={rowKey}
            className="cursor-pointer"
            locale={{
              emptyText: (
                <div className="flex flex-col justify-center items-center">
                  <span className="text-center mb-3 ">
                    {setStartDate && setEndDate && setSearchFilters
                      ? 'No Data'
                      : ''}
                  </span>
                </div>
              ),
            }}
          />
        </Flex>
      </div>
      <ModalComponent
        centered={true}
        open={isDeleteMultipleModalVisible}
        handleSubmit={handleDeleteMultipleEncounters}
        handleCancel={handleCancel}
        submitButtonText={`Delete ${selectedRowKeys?.length} item(s)`}
        cancelButtonText="Cancel"
        closable={false}
        className="!w-fit"
        submitLoading={submitLoading}
        additionalBody={
          <>
            {' '}
            <div className="text-black font-sans font-medium text-lg flex justify-center items-center gap-2">
              <span>
                {' '}
                <AlertIcon />
              </span>
              <p>
                This will permanently delete the encounters. Are you sure you
                want to delete?
              </p>
            </div>
          </>
        }
      />
    </>
  );
};
